<template>
  <LoaderView v-if="me == null" />

  <div v-else style="padding: 20px;">
    <div class="row">
      <div class="col-md-6">
        
        <div class="card" style="width: 100%; height: 100%;">
          <div class="form-title">Mon compte</div>

          <div class="form-group">
            <label class="form-label">Mon Email</label>
            <div style="display: flex;">
              <input
                v-if="editingEmail"
                class="form-input"
                v-model="editedEmail"
                style="margin-right: 10px;"
              >
              <input
                v-else
                disabled
                class="form-input"
                :value="email"
                style="margin-right: 10px;"
              >
              <button class="button" @click="toggleEditEmail">
                {{ editingEmail ? "Annuler" : "Modifier" }}
              </button>
              <button
                v-if="editingEmail"
                class="button"
                @click="updateEmail"
                style="margin-left: 5px;"
              >
                Enregistrer
              </button>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Mon Mot de passe</label>
            <div style="display: flex;">
              <input
                v-if="editingPassword"
                class="form-input"
                v-model="newPassword"
                type="password"
                placeholder="Nouveau mot de passe"
                style="margin-right: 10px;"
              >
              <input
                v-else
                disabled
                class="form-input"
                :value="password"
                style="margin-right: 10px;"
              >
              <button class="button" @click="toggleEditPassword">
                {{ editingPassword ? "Annuler" : "Modifier" }}
              </button>
              <button
                v-if="editingPassword"
                class="button"
                @click="updatePassword"
                style="margin-left: 5px;"
              >
                Enregistrer
              </button>
            </div>
          </div>

          <div v-if="emailEnabled" class="form-group">
            Je n'ai plus besoin de recevoir mes menus par email ? <a href="#" @click="toggleEmailEnabled" >Désactiver les envois d'emails</a>
          </div>

          <div v-else class="form-group">
            J'ai désactivé l'envois d'emails. <a href="#" @click="toggleEmailEnabled">Réactiver</a>
          </div>

          <div class="form-group">
            Je n'ai plus besoin de nos services ? <a href="#" class="danger" @click="openDeleteAccountModal">Supprimer mon compte</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Account Modal -->
    <div v-if="showDeleteAccountModal" class="modal">
      <div v-if="showAccountDeletedSuccess" class="modal-content">
        <h2>Votre compte a été supprimé avec succès</h2>

        <p>
          Vous allez être redirigé vers la page d'accueil dans quelques secondes.
        </p>
      </div>

      <div v-else-if="deletingAccount" class="modal-content">
        <LoaderView />
      </div>

      <div v-else class="modal-content">
        <h2>Supprimer mon compte</h2>

        <p>
          Voulez-vous vraiment supprimer votre compte ?
        </p>
        
        <p>
          Toutes vos données seront perdues. Cela inclus :
          <ul>
            <li>Votre historique de menu</li>
            <li>Vos favoris</li>
            <li>Vos préférences</li>
            <li>Les membres de votre foyer</li>
          </ul>
        </p>
        
        <p>
          Vous pouvez toujours recréer un nouveau compte ultérieurement.
        </p>

        <div style="display: flex; justify-content: flex-end;">
          <button @click="closeDeleteAccountModal" class="btn btn-lg">
            Annuler
          </button>
          <button @click="deleteAccount" class="btn btn-lg" style="margin-left: 10px;">
            Supprimer mon compte
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { userState } from "@/utils/store";
import LoaderView from "@/components/LoaderView.vue";

export default {
  name: "MyAccount",
  components: { LoaderView },
  data() {
    return {
      showDeleteAccountModal: false,
      deletingAccount: false,
      showAccountDeletedSuccess: false,

      editingEmail: false,
      editedEmail: "",
      editingPassword: false,
      newPassword: "",
    };
  },
  computed: {
    me() {
      return userState.me;
    },
    emailEnabled() {
      return this.me.email_enabled;
    },
    email() {
      return this.me.email;
    },
    password() {
      return "********";
    },
  },
  methods: {
    toggleEditEmail() {
      this.editingEmail = !this.editingEmail;
      this.editedEmail = this.email;
    },
    updateEmail() {
      userState.updateEmail(this.editedEmail)
        .then(() => {
          this.editingEmail = false;
        })
        .catch(err => {
          alert("Erreur lors de la mise à jour de l'email");
          console.error(err);
        });
    },
    toggleEditPassword() {
      this.editingPassword = !this.editingPassword;
      this.newPassword = "";
    },
    updatePassword() {
      userState.changePassword(this.newPassword)
        .then(() => {
          this.editingPassword = false;
          alert("Mot de passe mis à jour");
        })
        .catch(err => {
          alert("Erreur lors de la mise à jour du mot de passe");
          console.error(err);
        });
    },
    openDeleteAccountModal() {
      this.showDeleteAccountModal = true;
    },
    closeDeleteAccountModal() {
      this.showDeleteAccountModal = false;
      this.deletingAccount = false;
      this.showAccountDeletedSuccess = false;
    },
    deleteAccount() {
      this.deletingAccount = true;

      userState.deleteAccount()
        .then(() => {
          this.deletingAccount = false;
          this.showAccountDeletedSuccess = true;
          setTimeout(() => this.$router.push("/"), 2000);
        })
        .catch((error) => {
          this.deletingAccount = false;
          alert("Erreur lors de la suppression");
          console.error(error);
        });
    },
    toggleEmailEnabled() {
      this.togglingEmailEnabled = true;

      userState.toggleEmailEnabled()
        .finally(() => {
          this.togglingEmailEnabled = false;
        });
    },
  },
};

</script>


<style scoped>

</style>
